export class AppConfig {
    public environment: string = "";
    public tenantId: string = "";
    public clientId: string = "";
    public baseUrl: string = "";
    public apiUrl: string = "";
    public wssUrl: string = "";
    public historicSpendIframeUrl: string = "";
    public graphscopeUrl: string = "";
    public redirectUri: string = "";
    public autoSignIn: string = "";
    public popupForLogin: string = "";
    public cacheLocation: string = "";
    public instance: string = "";
    public oidcScopes: string[] = [];
    public graphScopes: string[] = [];
    public refreshUrl: string = "";
}
